import { ClassData } from "../../../common/dtos/classes.type";
import { trackingService } from "../../../common/services/tracking.service";
import { getIP } from "../../../common/utils/ip.util";
import { attachCampaignDataObject, getCookie } from "../../campaign";

interface FormData {
  name: string;
  email: string;
  phone: string;
}

export class EventsModalService {
  private static getFormData(uniqueStyle: string): FormData {
    return {
      name: $(`${uniqueStyle} #name`).val() as string,
      email: $(`${uniqueStyle} #email`).val() as string,
      phone: $(`${uniqueStyle} #phone`).val() as string,
    };
  }

  private static validateFormData(data: FormData): boolean {
    const isNameValid = this.validateName(data.name);
    const isEmailValid = this.validateEmail(data.email);
    const isPhoneValid = this.validatePhone(data.phone);

    if (!isNameValid) {
      this.showError(
        ".input-wrapper #name",
        "Please enter a valid name (at least 2 characters)."
      );
    } else {
      this.hideError(".input-wrapper #name");
    }

    if (!isEmailValid) {
      this.showError(
        ".input-wrapper #email",
        "Please enter a valid email address."
      );
    } else {
      this.hideError(".input-wrapper #email");
    }

    if (!isPhoneValid) {
      this.showError(
        ".input-wrapper #phone",
        "Please enter a valid phone number."
      );
    } else {
      this.hideError(".input-wrapper #phone");
    }

    return isNameValid && isEmailValid && isPhoneValid;
  }

  private static validateName(name: string): boolean {
    return name.trim().length >= 2;
  }

  private static validatePhone(phone: string): boolean {
    const phoneRegex = /^[+]?[0-9\s()-]{7,15}$/;
    return phoneRegex.test(phone);
  }

  private static showError(selector: string, message: string): void {
    const $input = $(selector);
    let $error = $input.next(".error-message");
    if (!$error.length) {
      $error = $("<div>").addClass("error-message");
      $input.after($error);
      $($error).show();
    }
    $error.text(message);
  }

  private static hideError(selector: string): void {
    const $input = $(selector);
    $input.next(".error-message").remove();
  }

  private static validateEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  private static async submitCRMData(
    formData: FormData,
    classData: ClassData,
    registrationLink: string
  ) {
    try {
      const nonce = ryb_connect_ajax?.nonce;
      if (!nonce) {
        throw new Error("Security nonce not found");
      }

      const currentUrl = new URL(window.location.href);
      const stepParam = currentUrl.searchParams.get("step");
      let updatedStep = stepParam ? parseInt(stepParam, 10) + 1 : 1;

      currentUrl.searchParams.set("step", updatedStep.toString());

      const response = await $.ajax({
        url: `https://${window.location.host}/wp-json/ryb/v1/ghl?timestamp=${Date.now()}`,
        method: "POST",
        contentType: "application/json",
        data: JSON.stringify({
          body: attachCampaignDataObject({
            name: formData.name,
            email: formData.email,
            phone: formData.phone,
            dnd: false,
            dndSettings: {
              Call: {
                status: "inactive",
                message: "",
              },
              Email: {
                status: "inactive",
                message: "",
              },
              SMS: {
                status: "inactive",
                message: "",
              },
              WhatsApp: {
                status: "inactive",
                message: "",
              },
              GMB: {
                status: "inactive",
                message: "",
              },
              FB: {
                status: "inactive",
                message: "",
              },
            },
            provider_id: 1,
            source: "website",
            customFields: [
              {
                key: "selected_class_id",
                field_value: classData.id,
              },
              {
                key: "selected_class_url",
                field_value: registrationLink,
              },
              {
                key: "last_funnel_url",
                field_value: window.location.href,
              },
            ],
          })
        })
      });

      if (!response.success) {
        trackingService.captureException(
          new Error(
            `${window.location.host} | Submit CRM data to GoHighLevel - GHL API responded with error in modal`
          ),
          {
            devMessage:
              "Check plugin logs, either the token was not refreshed or their API is down",
            response: response,
          }
        );
      }

          if(response.success === true && response?.data?.contact?.id) {
      const contactId = response?.data?.contact?.id;
      localStorage.setItem('ghlContactId', contactId);
      const tagsResponse = await $.ajax({
        url: `https://${window.location.host}/wp-json/ryb/v1/ghl?timestamp=${Date.now()}`,
        method: "POST",
        contentType: "application/json",
        data: JSON.stringify({
          request_url: `https://services.leadconnectorhq.com/contacts/${contactId}/tags`,
          include_location_id: false,
          body: {
            tags: document.querySelector("#class-finder.template-trials")
          ? ["trial"]
          : ["webFunnel"],
          }
        })
      })

      if (tagsResponse?.success === false) {
        trackingService.captureException(
          new Error(
            `${window.location.host} | Submit CRM data (TAGS) to GoHighLevel - GHL API responded with error in wizard step child`
          ),
          {
            devMessage:
              "Check plugin logs, the tag request failed, so the users will not have tags",
            response: response,
          }
        );
      }
    }

      return response;
    } catch (error) {
      trackingService.captureException(
        new Error(
          `${window.location.host} | Submit CRM data to GoHighLevel - GHL API responded with error in modal`
        ),
        {
          devMessage:
            "Check plugin logs, either the token was not refreshed or their API is down",
          error: error,
        }
      );

      return;
    }
  }

  private static async submitGAData(formData: FormData) {
    const classData = getCookie("classData");
    const eventData = attachCampaignDataObject({
      site_name: window.location.host,
      event: "lead created", // for enrollment - enroll, for contact form - lead created
      name: formData.name,
      email: formData?.email ? formData.email : "No email provided",
      timestamp: Date.now(),
      ip: await getIP(),
      page_title: document.querySelector("title")?.innerText,
      class_data: classData ? JSON.parse(atob(classData)) : {},
    });
    fetch("https://a.cloud.dive.games/ryb/events", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(eventData),
    })
      .then((data) => {
        console.log("Success:", data);
      })
      .catch((error) => {
        trackingService.captureException(
          new Error(
            `${window.location.host} | a.cloud.dive.games API returned error on request in modal popup`
          ),
          {
            devMessage: "a.cloud.dive.games returned error on request",
            requestObject: eventData,
            error: error,
          }
        );
        console.error("Error:", error);
      });
  }

  public static async handleSubmit(
    cardData: ClassData,
    registrationLink: string,
    uniqueStyle: string = ""
  ) {
    const data = this.getFormData(uniqueStyle);
    if (!this.validateFormData(data)) {
      return;
    }

    await this.submitCRMData(data, cardData, registrationLink);
    await this.submitGAData(data);
  }
}
